import { CityActions } from '../actions';
import { CityState } from '../city-state';

// важно, чтобы было undefined, а не DEFAULT_CITY например
// пока город не определён, не запускается логика, связанная с городом (например редиректы)
// поэтому город определяется в CityService, таким образом мы добиваемся инициализации городов ДО этой самой логики
export const initialState: CityState['activeBaseStore'] = undefined;

export function reducer(state = initialState, action: CityActions.SetActiveBaseStore): CityState['activeBaseStore'] {
  switch (action.type) {
    case CityActions.SET_ACTIVE_BASE_STORE: {
      return action.payload;
    }

    default: {
      return state;
    }
  }
}
